import springApi, { getDomain } from '../../services/springApi'

export const getCouponOrders = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/coupon_orders', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getCouponOrder = (id, params) => (
	new Promise((resolve, reject) => {
		springApi()
			.get(`/coupon_orders/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeCouponOrder = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/coupon_orders', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateCouponOrder = (id, data) => (
	new Promise((resolve, reject) => {
		springApi()
			.put(`/coupon_orders/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteCouponOrder = id => (
	new Promise((resolve, reject) => {
		springApi()
			.delete(`/coupon_orders/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchCouponOrders = async (name, token) => (
	fetch( getDomain()+`/coupon_orders?filter[name]=${name}&filter[active]=1`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(coupon_order => ({
				label: coupon_order.fullname,
				value: coupon_order.id,
			})),
		)
)